module.exports = __webpack_public_path__ + "static/media/DEFAULT_MEDIUM_AUDIO_2.004a1635.mpga";